<template>
  <FieldsetModel
    :ui="uiBaseFieldset"
    :name="name"
    ui-columns="2"
    :ui-title="title"
    :presence="presence"
  >
    <UiWrapper
      :name="FIELD_NAMES.appointmentDate"
      label="What day?"
      :validations="validations"
    >
      <DateWrapper />
    </UiWrapper>

    <UiWrapper
      :name="FIELD_NAMES.appointmentTime"
      label="Time"
    >
      <Dropdown
        placeholder="At what time?"
        :options="timeOptions"
      />
    </UiWrapper>
   
  </FieldsetModel>
</template>

<script>

import { Dropdown } from '@dunia/ui';

import DateWrapper from '@/forms/components/ui-dunia/date-wrapper';
import { isFutureDateCondition, withinMonthRange } from '@/forms/conditions';
import sharedComponentMixin from '@/forms/components/shared/shared-component-mixin';

import FIELDSET_NAMES from '@/forms/constants/fieldset-names';

export default {
  name: 'FieldsetAppointmentDate',

  props: {
    name: {
      type: String,
      default: FIELDSET_NAMES.appointmentSetDate,
    },
    title: {
      type: String,
      default: 'When would you like to meet?',
    },
    timeOptions: {
      type: Array,
      default: () => [
        {
          value: '7am - 9am',
          label: '7am - 9am',
        },
        {
          value: '9am - 11am',
          label: '9am - 11am',
        },
        {
          value: '11am - 1pm',
          label: '11am - 1pm',
        },
        {
          value: '1pm - 3pm',
          label: '1pm - 3pm',
        },
        {
          value: '3pm - 5pm',
          label: '3pm - 5pm',
        },
        {
          value: '5pm - 7pm',
          label: '5pm - 7pm',
        },
      ],
    },
    validations: {
      type: Array,
      default: () => ([
        {
          errorMessage: 'Please type a future date',
          condition: isFutureDateCondition,
          name: 'pp-is-futuredate',
        },
        {
          errorMessage: 'Please, write a date within a month\'s range',
          condition: withinMonthRange(1),
          name: 'date-in-range',
        },
      ]),
    },
    presence: {
      type: Boolean,
      default: true,
    },
  },

  mixins: [sharedComponentMixin],

  components: {
    DateWrapper,
    Dropdown,
  },
};
</script>
